export type Option = {
  label: string;
  value: string | number;
};
export enum SortDirection {
  asc = "ASC",
  desc = "DESC",
}

export type SortConfig = {
  sortBy?: string;
  sortDirection?: SortDirection;
};
export enum ManagementType {
  USER = "USER",
  PATIENT = "PATIENT",
  PATIENT_CARE = "PATIENT_CARE",
}

export type FilterParams = {
  title: string;
  checked: boolean;
  id: string;
  filterKey: FILTER_KEYS;
};

export type CommonApiParams = SortConfig & {
  limit: number;
  offset: number;
};

export type FilterDetailsParams = {
  startDate?: Date | null;
  endDate?: Date | null;
  examType?: string;
  examMinRange?: string;
  sports?: string;
  examTypes?: string;
  genders?: string;
  positions?: string;
  teams?: string;
  timeRange?: string;
  fromFilterModal?: boolean;
};

export type ApiPaginatedResponse<T> = {
  cliniciansList: any;
  items: T[];
  totalCount: number;
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum FILTER_KEYS {
  type = "type",
  joint = "jointId",
  score = "score",
}
export enum StatusENUM {
  active = "active",
  disabled = "disabled",
  invited = "invited",
  registered = "registered",
  expired = "expired",
}

export type ClinicUserInfo = {
  email: string;
  inviteDates?: string[];
};
